var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "mb-2 mt-2"
  }, _vm._l(_vm.attachments, function (image) {
    return _c('v-col', {
      key: image.id,
      attrs: {
        "cols": "3"
      }
    }, [_c('image-dialog', {
      attrs: {
        "src": image.url,
        "cardClass": "",
        "title": _vm.$t("image.".concat(image.type, ".type"))
      }
    })], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }